import { LicenseInfo } from "@mui/x-license";

export const initMui = () => {
  LicenseInfo.setLicenseKey(
    "128741feea5f634bb9d0b51ecd0d70f0Tz0xMzAzNTUsRT0xODEzNTM1OTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y"
  );
};
